module.exports = ".list-itens {\n    list-style-type: circle !important;\n    padding-left: 10px;\n}"